import { render, staticRenderFns } from "./gjf-pdf.vue?vue&type=template&id=3e8c4e8a&"
import script from "./gjf-pdf.vue?vue&type=script&lang=js&"
export * from "./gjf-pdf.vue?vue&type=script&lang=js&"
import style0 from "./gjf-pdf.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports